// extracted by mini-css-extract-plugin
module.exports = {"content":"Editor_content__5g9FP"};